module.exports = __webpack_public_path__ + "img/image33.f2594da2.png";